module.exports = {"description":{"ja":"対象のイベント :","en":"Selected Event :"},"cooperation":{"ja":"連携する","en":"Sync App"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/constants/confirmation/invalid-token/invalid-token.json
// module id = soBP
// module chunks = 1